import Vue from 'vue'

import axios from 'axios'

// Define mutation types
const SET_LOCATOR_EXPRESSION = 'SET_LOCATOR_EXPRESSION'
const SET_SELECTED_LOCATION = 'SET_SELECTED_LOCATION'
const SET_GO_TO_LOCATION = 'SET_GO_TO_LOCATION'
const SET_LOCATION_PRINTER = 'SET_LOCATION_PRINTER'
const SET_LOGS = 'SET_LOGS'
const SET_GROUPED_LOGS = 'SET_GROUPED_LOGS'
const UPDATE_DIRTY_DATA = 'UPDATE_DIRTY_DATA'
const RESET_DIRTY_DATUM = 'RESET_DIRTY_DATUM'
const SET_FOCUS_LOCATION = 'SET_FOCUS_LOCATION'
const SET_SHOW_LOGS = 'SET_SHOW_LOGS'
const SET_GET_METADATA = 'SET_GET_METADATA'
const SET_GET_METADATUM_LOCATION = 'SET_GET_METADATUM_LOCATION'
const SET_METADATA_RESETTER = 'SET_METADATA_RESETTER'
const SET_FILE_DETAILS = 'SET_FILE_DETAILS'
const SET_GET_CHANGES = 'SET_GET_CHANGES'
const SET_GET_DATA = 'SET_GET_DATA'
const SET_UNDO_CHANGE = 'SET_UNDO_CHANGE'
const SET_EXECUTION_RESULTS = 'SET_EXECUTION_RESULTS'
const UPDATE_STATES = 'UPDATE_STATES'
const RESET = 'RESET'

const BASE_URL = 'api/Services/Ingestions'
const FETCH_RESULTS_URL = (executionId) => `${BASE_URL}/Review/${executionId}`
const RESUBMIT_URL = (rdrFileId) => `${BASE_URL}/Resubmit/${rdrFileId}`

let initialState = () => ({
  executionResults: {},
  fileDetails: null,
  logs: [],
  showLogs: {
    error: true,
    warning: true,
    info: false,
  },
  states: {
    loadingResults: false,
    loadingSubmit: false,
    errorResults: false,
    canResubmit: true,
    hasJustResubmitted: false,
  },
  dirtyData: {},
  resetDirtyDatum: [],
  datumLogs: null,
  groupedLogs: {},
  selectedLocation: null,
  goToLocation: null,

  locator: () => {},
  locationPrinter: () => {},
  focusLocation: () => {},
  getMetadata: () => {},
  getMetadatumLocation: () => {},
  metadataResetter: () => {},
  getData: () => {},
  getChanges: () => {},
  undoChange: () => {},
})

import { groupBy } from '@/helpers/arrays'

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async loadExecutionResults({ commit, dispatch }, {
      executionId,
    }) {
      try {
        let response = await axios.get(FETCH_RESULTS_URL(executionId))
        let executionResults = response.data

        dispatch('setLogs', executionResults.ExecutionLogs)
        commit(SET_FILE_DETAILS, executionResults.FileDetails)
        commit(SET_EXECUTION_RESULTS, executionResults)
        return executionResults
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
    async resubmitData(_, {
      fileId,
      resubmitData,
      isAlreadySaved,
    }) {
      try {
        console.log('rd', resubmitData)
        let response = await axios.put(RESUBMIT_URL(fileId), {
          resubmitData,
          isAlreadySaved,
        })

        return response.data
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
    setFocusLocation({ commit }, focusLocation) {
      commit(SET_FOCUS_LOCATION, focusLocation)
    },
    async removeLogs({ getters, dispatch }, logLocations) {
      let logs = getters.logs
      let removedLogs = []

      logLocations.forEach(logLocation => {
        let indexes = []
        logs.forEach((log, index) => {
          if (log.location == logLocation) {
            removedLogs.push(log)
            indexes.push(index)
          }
        })

        indexes.reverse().forEach(index => {
          logs.splice(index, 1)
        })
      })

      await dispatch('setLogs', logs)
      return removedLogs
    },
    setGetMetadata({ commit }, getMetadata) {
      commit(SET_GET_METADATA, getMetadata)
    },
    setGetMetadatumLocation({ commit }, getMetadatumLocation) {
      commit(SET_GET_METADATUM_LOCATION, getMetadatumLocation)
    },
    async addLogs({ state, dispatch }, logs) {
      let newLogs = [
        ...state.logs,
        ...logs,
      ]

      await dispatch('setLogs', newLogs)
    },
    setLogs({ commit }, logs) {
      commit(SET_LOGS, logs)

      let groupedLogs = groupBy(logs, log => log.location)
      commit(SET_GROUPED_LOGS, groupedLogs)
    },
    setShowLogs({ commit }, showLogs) {
      commit(SET_SHOW_LOGS, showLogs)
    },
    setLocatorExpression({ commit }, locator) {
      commit(SET_LOCATOR_EXPRESSION, locator)
    },
    setSelectedLocation({ commit }, selectedLocation) {
      commit(SET_SELECTED_LOCATION, selectedLocation)
    },
    goToLocation({ commit }, location) {
      commit(SET_GO_TO_LOCATION, location)
    },
    setLocationPrinterExpression({ commit }, locationPrinter) {
      commit(SET_LOCATION_PRINTER, locationPrinter)
    },
    setUndoChange({ commit }, undoChange) {
      commit(SET_UNDO_CHANGE, undoChange)
    },
    updateDirtyData({ commit }, [location, value]) {
      commit(UPDATE_DIRTY_DATA, [location, value])
    },
    async updateLogLocations({ getters, dispatch }, logLocations) {
      let logs = getters.logs

      logs.forEach(log => {
        let newLocation = logLocations[log.location]
        if (newLocation) {
          log.location = newLocation
        }
      })

      await dispatch('setLogs', logs)
    },
    resetDirtyDatum({ commit }, locations) {
      commit(RESET_DIRTY_DATUM, locations)
    },
    setMetadataResetter({ commit }, metadataResetter) {
      commit(SET_METADATA_RESETTER, metadataResetter)
    },
    updateStates({ commit }, states) {
      commit(UPDATE_STATES, states)
    },
    setGetChanges({ commit }, getChanges) {
      commit(SET_GET_CHANGES, getChanges)
    },
    setGetData({ commit }, getData) {
      commit(SET_GET_DATA, getData)
    },
    reset({ commit }) {
      commit(RESET)
    },
  },
  mutations: {
    [SET_EXECUTION_RESULTS](state, executionResults) {
      state.executionResults = executionResults
    },
    [UPDATE_STATES](state, states) {
      state.states = {
        ...state.states,
        ...states,
      }
    },
    [SET_UNDO_CHANGE](state, undoChange) {
      state.undoChange = undoChange
    },
    [SET_GET_METADATA](state, getMetadata) {
      state.getMetadata = getMetadata
    },
    [SET_GET_METADATUM_LOCATION](state, getMetadatumLocation) {
      state.getMetadatumLocation = getMetadatumLocation
    },
    [SET_FOCUS_LOCATION](state, focusLocation) {
      state.focusLocation = focusLocation

      Vue.nextTick(() => {
        state.focusLocation = null
      })
    },
    [UPDATE_DIRTY_DATA](state, [location, value]) {
      if (value != null)
        state.dirtyData = Object.assign({}, state.dirtyData, {
          [location]: value,
        })
      else {
        Vue.delete(state.dirtyData, location)
      }
    },
    [RESET_DIRTY_DATUM](state, locations) {
      state.resetDirtyDatum = [...new Set(locations)]
    },
    [SET_LOGS](state, logs) {
      state.logs = logs
    },
    [SET_GROUPED_LOGS](state, groupedLogs) {
      state.groupedLogs = groupedLogs
    },
    [SET_SHOW_LOGS](state, showLogs) {
      state.showLogs = showLogs
    },
    [SET_LOCATOR_EXPRESSION](state, locator) {
      state.locator = locator
    },
    [SET_SELECTED_LOCATION](state, selectedLocation) {
      state.selectedLocation = selectedLocation
    },
    [SET_GO_TO_LOCATION](state, location) {
      state.goToLocation = location

      Vue.nextTick(() => {
        state.goToLocation = null
      })
    },
    [SET_LOCATION_PRINTER](state, locationPrinter) {
      state.locationPrinter = locationPrinter
    },
    [SET_METADATA_RESETTER](state, metadataResetter) {
      state.metadataResetter = metadataResetter
    },
    [SET_FILE_DETAILS](state, fileDetails) {
      state.fileDetails = fileDetails
    },
    [SET_GET_CHANGES](state, getChanges) {
      state.getChanges = getChanges
    },
    [SET_GET_DATA](state, getData) {
      state.getData = getData
    },
    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
  },
  getters: {
    states: (state) => state.states,
    logs: (state) => state.logs,
    logsMeta: (state, getters) => {
      let printedLocation, displayName, fullName

      let index = {}
      state.logs.forEach(log => {
        printedLocation = getters.locationPrinter(log.location)
        displayName = log.location
        fullName = log.location

        if (printedLocation) {
          displayName = printedLocation.displayName
          fullName = printedLocation.fullName
        }

        index[log.location] = {
          displayName,
          fullName,
        }
      })

      return index
    },
    showLogs: (state) => state.showLogs,
    shownLogs: (state, getters) => getters.logs.filter(log => state.showLogs[log.severity]),
    groupedLogs: (state) => state.groupedLogs,
    locator: (state) => (location) => {
      if (state.locator) return state.locator(location)
      return
    },
    selectedLocation: (state) => state.selectedLocation,
    goToLocation: (state) => state.goToLocation,
    locationPrinter: (state) => (location) => state.locationPrinter && state.locationPrinter(location),
    isDirty: (state, getters) => (datum) => {
      if (!datum) return
      return getters.isLocationDirty(datum.location)
    },
    dirtyData: (state) => state.dirtyData,
    resetDirtyDatum: (state) => state.resetDirtyDatum,
    focusLocation: (state) => state.focusLocation,
    getMetadata: (state) => () => state.getMetadata,
    getMetadatumLocation: (state) => (location) => {
      if (state.getMetadatumLocation) return state.getMetadatumLocation(location)
      return
    },
    metadataResetter: (state) => (location) => {
      if (state.metadataResetter) return state.metadataResetter(location)
      return
    },
    undoChange: (state) => state.undoChange,
    getChanges: (state) => state.getChanges,
  },
}